// NOTE: This uses the "old" subscription builder code.
// I figured that since it was much more simple and less
// integral we didn't need to rewrite it when we rewrote
// the primary subscription builder

export default class GiftSubscriptionForm {
  constructor() {
    this.formEl = document.querySelector('.js-gift_subscription-form');

    if (this.formEl) {
      this.submitEl = this.formEl.querySelector('.js-submit');
      this.giftCodeInputEl = this.formEl.querySelector('.js-gift-code');
      this.optionElements = this.formEl.querySelectorAll('.js-subscription_option');
      this.init();
    }
  }

  init() {
    // 1. On page load, see if there is already a value
    this.optionElements.forEach(element => {
      const optionHandle = element.dataset.optionHandle;
      const optionValue = document.querySelector(`input[name='fields[${optionHandle}]']`).value;
      if (optionValue === element.dataset.value) {
        element.classList.add('is-selected');
        element.closest('.js-scrollto-unless-complete').classList.add('is-complete');
        const summaryItem = document.querySelector(`.js-summary-item[data-option-handle='${optionHandle}']`);
        summaryItem.classList.remove('is-empty');
        summaryItem.innerHTML = optionValue;
      }
    });

    // 2. Edit the value on click
    this.optionElements.forEach(element => {
      element.addEventListener('click', (event) => {
        event.preventDefault();
        this.toggleOption(event.currentTarget);
      });
    });

    // 3. Submit if able
    this.submitEl.addEventListener('click', (event) => {
      if (this.formEl.classList.contains('is-ready')) {
        return true;
      }
      event.preventDefault();
      GiftSubscriptionForm.scrollToIncomplete();
      return true;
    });

    // Consider it complete if they hit a certain min length
    this.giftCodeInputEl.addEventListener('input', (event) => {
      const input = event.target;
      if (input.value.length > 9) {
        input.classList.add('is-selected');
        input.closest('.js-scrollto-unless-complete').classList.add('is-complete');
      } else {
        input.classList.remove('is-selected');
        input.closest('.js-scrollto-unless-complete').classList.remove('is-complete');
      }
    });

    // Move to the next section if they hit enter
    this.giftCodeInputEl.addEventListener('keypress', (event) => {
      if (event.key === 'Enter') {
        GiftSubscriptionForm.scrollToIncomplete();
        event.preventDefault();
        return false;
      }
      return true;
    });
  }

  toggleOption(optionEl) {
    // Dictionary: (We are using slightly different words/meanings than Shopify
    //   so this will hopefully provide clarify.) For us, a Property is a group
    //   of options, an Option is a specific option.

    // Get the value
    const optionValue = optionEl.dataset.value;
    // Get something that we can identify it's sibling groups by, we'll make sure
    //   they all have the same data-option-handle set
    const optionHandle = optionEl.dataset.optionHandle;
    const optionSiblings = document.querySelectorAll(`.js-subscription_option[data-option-handle='${optionHandle}']`);
    optionSiblings.forEach(sibling => sibling.classList.remove('is-selected'));

    // 1. Add the check mark and remove it from siblings
    optionEl.classList.add('is-selected');
    optionEl.closest('.js-scrollto-unless-complete').classList.add('is-complete');

    // 2. Change the value of the associated fields based on what this one is
    document.querySelector(`input[name='fields[${optionHandle}]']`).value = optionValue;
    // 2a. Show the value in the summary.
    const summaryItem = document.querySelector(`.js-summary-item[data-option-handle='${optionHandle}']`);
    summaryItem.classList.remove('is-empty');
    summaryItem.innerHTML = optionValue;

    // 3. Check if it's the last needed option
    const totalProperties = document.querySelectorAll('.js-subscription_property').length - 1;
    const selectedProperties = document.querySelectorAll('.js-subscription_option.is-selected').length;

    if ((totalProperties === selectedProperties) && this.giftCodeInputEl.classList.contains('is-selected')) {
      this.formEl.classList.add('is-ready');
    }

    // Always scroll to the next not complete section (could be the summary)
    setTimeout(() => {
      GiftSubscriptionForm.scrollToIncomplete();
    }, 300);
  }

  static scrollToIncomplete() {
    document.querySelector('.js-scrollto-unless-complete:not(.is-complete)').scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
  }
}
